// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1_DIn","cls2":"PaperAbstract-cls2_thd PaperAbstract-cls1_DIn","variant-dense":"PaperAbstract-variant-dense_KPn"};